module.exports = __webpack_public_path__ + "static/handgemacht_logo-bdaa923c4c8f3424c646c818d3e26a1c.png";